import React from 'react'
import lider from '../../assets/img/lider.svg'
import {getGrocersImg} from '../../componentsRef/CreateCatalog/helpers'
import { useParams } from 'react-router-dom'

export const IngresoPromocionHeader = ({nroSku = 0, promotion, 
	setSimulacionProcess, 
	simulacionProcess,
	Spinner,
	simulacionData,
	viewPage,
	typePromotion
}) => {
	const { idPromocion, estadoPromocion } = useParams()
	return (
		<div className='IngresoPromocionHeader'>
			<div className='left-area-header'>
				
				<div className='box'>
					<h1>Promo Type</h1>
					<p>{promotion && typePromotion}</p>
				</div>
				<div className='box'>
					<h1>Catalog Name</h1>
					<p>{promotion && promotion.data_promocion.nombre_promocion}</p>
				</div>
			</div>
			<div className='middle-area-header'>
				<div className='box'>
					<h1>Customer</h1>
					<div className='box-inner'>
						{/* <img src={lider} alt='' /> */}
					{promotion && 
						<img src={getGrocersImg(String(promotion.data_promocion.nombre_cadena).replace(/\s/g, ''))} alt='' />
							}
					</div>
				</div>
				<div className='box'>
					<h1>Phase</h1>
					<div className='box-inner blue box-inner-120'>
						<p className='small'>{promotion && promotion.data_promocion.fase_str}</p>
					</div>
				</div>
				<div className='box'>
					<h1>Created On</h1>
					<div className='box-inner box-inner-120'>
						<p className='small'>{promotion && promotion.data_promocion.fecha_ingreso}</p>
					</div>
				</div>
				<div className='box'>
					<h1>Last Updated</h1>
					<div className='box-inner box-inner-120'>
						<p className='small'>{
						promotion && 
							promotion.data_promocion.fecha_actualizacion !== '' ?
							promotion.data_promocion.fecha_actualizacion :
							promotion.data_promocion.fecha_ingreso
						}</p>
					</div>
				</div>
			</div>

			<div className='end-area-header'>
				
				<div className='box small-last'>
					<h1>ROI</h1>
					<p className='small'>{
					 (simulacionData && !simulacionProcess) ? simulacionData.data_promocion.roi+"%"
					 : <Spinner type={true}/>
					}
					
					</p>
				</div>
				
				<div className='box small-last'>
					<h1>Uplift</h1>
					<p className='small'>{(simulacionData && !simulacionProcess) ? simulacionData.data_promocion.uplift+"%" : <Spinner type={true}/>}</p>
				</div>
				<div className='box small-last'>
					<h1>Baseline (Kgs.)</h1>
					<p className='small'>{(simulacionData && !simulacionProcess) ? simulacionData.data_promocion.baseline : <Spinner type={true}/>}</p>
				</div>
				<div className='box small-last'>
					<h1>Promotional Mg.</h1>
					<p className='small'>{
						(simulacionData && !simulacionProcess) ? "$"+simulacionData.data_promocion.margen_comercial : <Spinner type={true}/>
					}</p>
				</div>
				
				<div className='box small-last'>
					<h1>N° SKU</h1>
					<p className='small'>{nroSku}</p>
				</div>
				{ /* 
				<div className='box small-last'>
					<h1>Mg. Comercial Incr.</h1>
					<p className='small'>
						{
							(simulacionData && !simulacionProcess) ? "$"+simulacionData.data_promocion.margen_comercial_incremental : <Spinner type={true}/>
						}
					</p>
					</div> */ }
			{!viewPage ?
				(estadoPromocion === "1" || estadoPromocion === "3" || 
				
				(
					estadoPromocion === "5" && (
					localStorage.getItem('rol') === "SUPER ADMIN" ||
					localStorage.getItem('rol') === "APROBADOR" 
					)
				)
				) &&
				<button 
					onClick={(e) => {
						setSimulacionProcess(true)
					}}
					disabled={simulacionProcess}
				>
					{!simulacionProcess ? 'Simulate' : 'Simulating' }
					{!simulacionProcess ? 
					<svg
						width='12'
						height='12'
						viewBox='0 0 12 12'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<g clipPath='url(#clip0_640_473210)'>
							<mask
								id='mask0_640_473210'
								maskUnits='userSpaceOnUse'
								x='0'
								y='0'
								width='12'
								height='12'
							>
								<rect width='12' height='12' fill='#D9D9D9' />
							</mask>
							<g mask='url(#mask0_640_473210)'>
								<path
									d='M1.55007 10.05C1.24174 10.05 0.981407 9.94362 0.769073 9.73095C0.556407 9.51862 0.450073 9.25828 0.450073 8.94995C0.450073 8.64995 0.558407 8.39378 0.775073 8.18145C0.99174 7.96879 1.25007 7.86245 1.55007 7.86245H1.69407C1.73974 7.86245 1.78341 7.87078 1.82507 7.88745L3.93757 5.78745C3.92091 5.73745 3.91257 5.68945 3.91257 5.64345V5.49995C3.91257 5.19995 4.01891 4.94362 4.23157 4.73095C4.44391 4.51862 4.70007 4.41245 5.00007 4.41245C5.30007 4.41245 5.55641 4.51862 5.76907 4.73095C5.98141 4.94362 6.08757 5.19995 6.08757 5.49995C6.08757 5.53328 6.07924 5.62495 6.06257 5.77495L7.22507 6.93745C7.27507 6.92078 7.32091 6.91245 7.36257 6.91245H7.64407C7.68974 6.91245 7.73341 6.92078 7.77507 6.93745L9.38757 5.32495C9.37091 5.28328 9.36257 5.23945 9.36257 5.19345V5.04995C9.36257 4.74995 9.46891 4.49162 9.68157 4.27495C9.89391 4.05828 10.1501 3.94995 10.4501 3.94995C10.7584 3.94995 11.0189 4.05612 11.2316 4.26845C11.4439 4.48112 11.5501 4.74162 11.5501 5.04995C11.5501 5.34995 11.4417 5.60612 11.2251 5.81845C11.0084 6.03112 10.7501 6.13745 10.4501 6.13745H10.3066C10.2606 6.13745 10.2167 6.12912 10.1751 6.11245L8.56257 7.72495C8.57924 7.76662 8.58757 7.81028 8.58757 7.85595V7.99995C8.58757 8.29995 8.48141 8.55628 8.26907 8.76895C8.05641 8.98128 7.80007 9.08745 7.50007 9.08745C7.20007 9.08745 6.94391 8.98128 6.73157 8.76895C6.51891 8.55628 6.41257 8.29995 6.41257 7.99995V7.85595C6.41257 7.81028 6.42091 7.76245 6.43757 7.71245L5.28757 6.56245C5.23757 6.57912 5.18974 6.58745 5.14407 6.58745H5.00007C4.96674 6.58745 4.87507 6.57912 4.72507 6.56245L2.61257 8.67495C2.62924 8.72495 2.63757 8.77078 2.63757 8.81245V8.94995C2.63757 9.24995 2.53141 9.50829 2.31907 9.72495C2.10641 9.94162 1.85007 10.05 1.55007 10.05ZM2.00007 5.06245L1.66257 4.33745L0.937573 3.99995L1.66257 3.66245L2.00007 2.93745L2.33757 3.66245L3.06257 3.99995L2.33757 4.33745L2.00007 5.06245ZM7.50007 4.61245L6.98757 3.51245L5.88757 2.99995L6.98757 2.48745L7.50007 1.38745L8.01257 2.48745L9.11257 2.99995L8.01257 3.51245L7.50007 4.61245Z'
									fill='white'
								/>
							</g>
						</g>
						<defs>
							<clipPath id='clip0_640_473210'>
								<rect width='12' height='12' fill='white' />
							</clipPath>
						</defs>
					</svg>
					: ''}
				</button>
				: <></>
				}
			</div>
		</div>
	)
}
